// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AVSok","actions":"styles_actions__u3ujZ"};